// // components/payment/SquareSection.js

// import {
//     Box,
//     Button,
//     Spinner,
//     Checkbox,
//     Text,
//     Tooltip,
//     VStack,
//     useToast,
//     useColorModeValue,
//   } from "@chakra-ui/react";
//   import { InfoOutlineIcon } from "@chakra-ui/icons";
//   import React, { useState, useEffect } from "react";
//   import axios from "axios";
//   import API_BASE_URL from "config/api";
//   import DisconnectSquareButton from "views/admin/profile/components/Squarecomponent/DisconnectSquareButton.js"
//   export default function SquareSection() {
//     const [squareData, setSquareData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [connectError, setConnectError] = useState(false);
//     const [agree, setAgree] = useState(false); // ✅ 추가
//     const toast = useToast();
//       const handleSyncSquareProducts = async (auto = false) => {
//         try {
//           const token = localStorage.getItem("access_token");
//           if (!token) throw new Error("No token found");
      
//           const response = await axios.post(`${API_BASE_URL}/api/payments/square/sync-square-products/`, null, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
      
//           if (response.status === 200) {
//             toast({
//               title: "Square Products Synced",
//               description: auto
//                 ? "Square products automatically synced after connection."
//                 : "Products synced successfully!",
//               status: "success",
//               duration: 4000,
//               isClosable: true,
//             });
//           }
//         } catch (error) {
//           console.error("❌ Failed to sync Square products:", error);
//           alert("Failed to sync products. Check logs.");
//         }
//       };
//       const fetchSquareData = async () => {
//         try {
//           setLoading(true);
//           const token = localStorage.getItem("access_token");
//           if (!token) throw new Error("No token found");
  
//           const response = await axios.get(`${API_BASE_URL}/api/payments/square/account`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
  
//           if (response.status === 200) {
//             setSquareData(response.data);
//           }
//         } catch (error) {
//           console.error("Failed to fetch Square account data:", error);
//           setConnectError(true);
//         } finally {
//           setLoading(false);
//         }
//       };

//     useEffect(() => {
//       fetchSquareData();
//     }, []);
//     const [wasConnected, setWasConnected] = useState(false);

//     useEffect(() => {
//       if (squareData?.connected && !wasConnected) {
//         setWasConnected(true);
//         // 👇 자동 sync 제거 (원하면 버튼 클릭으로만 실행)
//         // handleSyncSquareProducts(true);
//       }
//     }, [squareData, wasConnected]);
    

//     // ✅ 3️⃣ Connect 버튼 동작
//     const handleConnectSquare = async () => {
//       try {
//         const token = localStorage.getItem("access_token");
//         if (!token) throw new Error("No token found");
//         // ✅ 1️⃣ 동의 로그 남기기
//         await axios.post(`${API_BASE_URL}/api/payments/consent/`, {
//           platform: "square",
//           agreed: true,
//           version: "v1.0"
//         }, { headers: { Authorization: `Bearer ${token}` } });

//         // ✅ 2️⃣ Square OAuth 요청
//         const response = await axios.get(`${API_BASE_URL}/api/payments/square/connect`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
  
//         if (response.status === 200) {
//           // window.location.href = response.data.url;
//           window.open(response.data.url, "_self");
//         }
//       } catch (error) {
//         console.error("Failed to connect to Square:", error);
//       }
//     };

//     // ✅ 4️⃣ Product 동기화
//     const cardBg = useColorModeValue("white", "gray.700");
    
    

    
//     return (
//       <Box borderWidth="1px" borderRadius="md" p={5} mb={6} bg={cardBg}>
//         <Text fontSize="xl" fontWeight="bold" mb={4}>
//           Square Integration
//         </Text>
//         {/* <Button colorScheme="red" onClick={handleRevokeSquare}>
//         Disconnect Square
//         </Button> */}
  
//         {loading ? (
//           <Box textAlign="center" py="20px">
//             <Spinner size="lg" />
//             <Text>Loading Square Info...</Text>
//           </Box>
//         ) : squareData?.connected && !connectError ? (
            
//           <VStack align="start" spacing={2}>
//             <Text><strong>Business Name:</strong> {squareData.business_name || "N/A"}</Text>
//             <Text><strong>Location:</strong> {squareData.location || "N/A"}</Text>
//             <Text><strong>Country:</strong> {squareData.country || "N/A"}</Text>
//             <Box display="flex" alignItems="center">
//               <Text>
//                 <strong>Sales Integration Enabled:</strong>{" "}
//                 {squareData.sales_enabled ? "Yes" : "No"}
//               </Text>
              
//               <Tooltip label="Shows if sales data sync is active." fontSize="md" placement="right">
//                 <InfoOutlineIcon w={4} h={4} cursor="pointer" ml="2" />
//               </Tooltip>
              
//             </Box>
//             <Button colorScheme="blue" mt={4} onClick={handleSyncSquareProducts}>
//                 Sync Products
//             </Button>
//             <DisconnectSquareButton onDisconnected={() => setSquareData(null)} />
//           </VStack>
          
//         ) : (
//           <VStack align="start" spacing={3}>
//           <Checkbox
//             isChecked={agree}
//             onChange={(e) => setAgree(e.target.checked)}
//             colorScheme="purple"
//           >
//             I agree that my Square sales and product data may be securely stored and analyzed
//             to improve my revenue predictions.
//           </Checkbox>
//           <Button
//             colorScheme="purple"
//             onClick={handleConnectSquare}
//             isDisabled={!agree}
//           >
//             Connect Account
//           </Button>
//         </VStack>
//         )}
//       </Box>
//     );
//   }
// components/payment/SquareSectionTailwind.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "config/api";
import { MdOutlineLogout, MdOutlineCheckCircle } from "react-icons/md";
import { FaSquare } from "react-icons/fa6";

export default function SquareSection() {
  const [squareData, setSquareData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [agree, setAgree] = useState(false);
  const [connectError, setConnectError] = useState(false);

  // ✅ Square 데이터 불러오기
  const fetchSquareData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      const response = await axios.get(`${API_BASE_URL}/api/payments/square/account`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) setSquareData(response.data);
    } catch (error) {
      console.error("Failed to fetch Square account data:", error);
      setConnectError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSquareData();
  }, []);

  // ✅ Square 연결
  const handleConnectSquare = async () => {
    try {
      const token = localStorage.getItem("access_token");
      if (!token) throw new Error("No token found");

      // 동의 로그
      await axios.post(
        `${API_BASE_URL}/api/payments/consent/`,
        { platform: "square", agreed: true, version: "v1.0" },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // OAuth 요청
      const response = await axios.get(`${API_BASE_URL}/api/payments/square/connect`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.status === 200 && response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.error("Failed to connect to Square:", error);
    }
  };

  // ✅ 동기화
  const handleSyncSquareProducts = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        `${API_BASE_URL}/api/payments/square/sync-square-products/`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200) {
        alert("✅ Square products synced successfully!");
      }
    } catch (error) {
      console.error("Failed to sync Square products:", error);
      alert("❌ Failed to sync products. Check logs.");
    }
  };

  // ✅ 연결 해제
  const handleDisconnectSquare = async () => {
    if (!window.confirm("Disconnect Square?")) return;
    try {
      const token = localStorage.getItem("access_token");
      await axios.post(
        `${API_BASE_URL}/api/payments/disconnect/`,
        { platform: "square" },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSquareData(null);
    } catch (error) {
      console.error("Failed to disconnect Square:", error);
    }
  };

  // ✅ 로딩 상태
  if (loading) {
    return (
      <div className="flex justify-center py-4">
        <span className="text-gray-400 text-sm">Loading Square info...</span>
      </div>
    );
  }

  // ✅ UI
  return (
    <div className="flex items-center justify-between bg-neutral-950 border border-neutral-800 rounded-lg p-4 mb-4">
      <div className="flex items-center gap-3">
        <FaSquare className="text-green-400 text-3xl" />
        <div>
          <p className="text-lg font-medium">Square</p>
          <p className="text-gray-400 text-sm">
            Connect your Square POS account to sync transactions.
          </p>
        </div>
      </div>

      {squareData?.connected && !connectError ? (
        <div className="flex items-center gap-3">
          <MdOutlineCheckCircle className="text-green-400 text-xl" />
          <button
            onClick={handleSyncSquareProducts}
            className="bg-blue-500 hover:bg-blue-400 px-3 py-1.5 rounded-md text-sm font-medium"
          >
            Sync Products
          </button>
          <button
            onClick={handleDisconnectSquare}
            className="flex items-center gap-1 bg-neutral-800 hover:bg-neutral-700 px-3 py-1.5 rounded-md text-sm"
          >
            <MdOutlineLogout /> Disconnect
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-end gap-2">
          <label className="flex items-center gap-2 text-sm text-gray-400">
            <input
              type="checkbox"
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
              className="accent-yellow-400"
            />
            I agree to connect my Square account.
          </label>
          <button
            onClick={handleConnectSquare}
            disabled={!agree}
            className={`px-4 py-2 rounded-md text-sm font-medium ${
              agree
                ? "bg-green-500 hover:bg-green-400"
                : "bg-gray-600 cursor-not-allowed"
            }`}
          >
            Connect Square
          </button>
        </div>
      )}
    </div>
  );
}